<template lang="pug">
.bloco-alerta-monitoramento-socioambiental
    .alerta-bloco
        .alerta-bloco--icone
            i.mdi.mdi-alert-outline.mdi-36px

        .alerta-bloco--conteudo
            .bloco-links
                ul
                    li
                        a(
                            @click='atualizarTempoAlertas("DIA")',
                            :class='tempoAlertas === "DIA" ? "ativo" : ""'
                        ) {{ $t('mensagens.blocoAlerta.filtros.hoje') }}
                    li
                        a(
                            @click='atualizarTempoAlertas("SEMANA")',
                            :class='tempoAlertas === "SEMANA" ? "ativo" : ""'
                        ) {{ $t('mensagens.blocoAlerta.filtros.seteDias') }}
                    li
                        a(
                            @click='atualizarTempoAlertas("MES")',
                            :class='tempoAlertas === "MES" ? "ativo" : ""'
                        ) {{ $t('mensagens.blocoAlerta.filtros.trintaDias') }}
                    li
                        a(
                            @click='atualizarTempoAlertas("TODO")',
                            :class='tempoAlertas === "TODO" ? "ativo" : ""'
                        ) {{ $t('mensagens.blocoAlerta.filtros.todoPeriodo') }}

            .bloco-dados
                .bloco-interno
                    span {{ quantidadeAlertas }}
                    .bloco-interno--texto {{ $t('mensagens.blocoAlerta.alertaEncontradoTerritorioMonitorado') }}
</template>

<script>
import AlertaService from '@/services/AlertaService.js';

export default {
    name: 'BlocoAlertaVisualizarMonitoramentoSocioambiental',

    data() {
        return {
            tempoAlertas: 'DIA',
            totalAlertas: null
        };
    },

    computed: {
        quantidadeAlertas() {
            if (!this.totalAlertas) {
                return '-';
            }

            if (this.tempoAlertas === 'DIA') {
                return this.totalAlertas.totalDiario;
            }

            if (this.tempoAlertas === 'SEMANA') {
                return this.totalAlertas.totalSemanal;
            }
            if (this.tempoAlertas === 'TODO') {
                return this.totalAlertas.total;
            }

            return this.totalAlertas.totalMensal;
        }
    },

    async mounted() {
        this.getResumo();
    },

    methods: {
        getResumo() {
            if (this.$route.params.idAreaMonitorada) {
                AlertaService.getResumoAlertasAreaMonitorada(
                    this.$route.params.idAreaMonitorada
                )
                    .then(({ data }) => {
                        this.totalAlertas = data;
                    })
                    .catch(erro => {
                        this.$notify.error({
                            message: `Ocorreu um erro ao buscar o total - ${erro}`
                        });
                    });
            }
        },
        atualizarTempoAlertas(tempo) {
            this.tempoAlertas = tempo;
        }
    }
};
</script>

<style lang="scss" scoped>
.alerta-bloco {
    background: #ef99181a;
    display: flex;
    justify-content: flex-start;
    border-radius: 8px;
    align-items: center;
    margin-left: 2px;

    .alerta-bloco--conteudo {
        padding: 5px 8px;

        .bloco-links {
            height: 100%;
            display: flex;
            align-items: center;

            ul {
                margin: 0;
                padding: 0;
                display: flex;

                li {
                    list-style: none;
                    margin-right: 25px;
                    padding: 7px;
                    color: var(--primary);

                    a:not(.ativo) {
                        cursor: pointer;
                        text-decoration: none;
                    }
                    a:hover {
                        cursor: pointer;
                    }
                    a.ativo:hover {
                        text-decoration: underline;
                        text-decoration-color: var(--warning);
                        text-underline-offset: 5px;
                        text-decoration-thickness: 2px;
                    }
                }
            }
        }
        .bloco-dados {
            margin: 0 8px;

            .bloco-interno {
                display: flex;
                align-items: baseline;
                height: 100%;
                font-weight: 600;
                padding-top: 5px;
                flex-wrap: wrap;

                span {
                    font-size: 22px;
                    color: #3b3b3b;
                    margin-right: 10px;
                }
            }
        }
    }
    .alerta-bloco--icone {
        background: var(--warning);
        width: 77px;
        height: 77px;
        display: flex;
        align-items: center;
        justify-content: center;
        border-top-left-radius: 8px;
        border-bottom-left-radius: 8px;
        color: var(--white);
    }

    .ativo {
        font-weight: bold;
        text-decoration: underline;
        text-decoration-color: var(--warning);
        text-underline-offset: 5px;
        text-decoration-thickness: 2px;
    }
}
</style>
